;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import { assetFragment, iconFragment } from 'lib/graphql/fragments';

import BlockCardSwipe from './BlockCardSwipe';

const query = /* GraphQL */ `
    ${assetFragment}
    ${iconFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockCardSwipe(preview: $preview, id: $id) {
            __typename
            anchorId
            title
            image {
                ...Asset
            }
            imageLarge {
                ...Asset
            }
            cover
            icon {
                ...Asset
            }
            cardsCollection(limit: 10) {
                items {
                    eyebrow
                    copy {
                        json
                    }
                    icon
                    icon2 {
                        ... on Icon {
                            ...Icon
                        }
                    }
                }
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockCardSwipe },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockCardSwipe;
}

const BlockCardSwipeServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return <BlockCardSwipe {...block} cards={block.cardsCollection.items} />;
};

export default BlockCardSwipeServer;
